export class LocationTree {
  id: number | string;
  name: string;
  locationId: string | number;                   // For Angular internal
  locationName: string;                          // For Angular internal
  childNode: Array<LocationTree> = [];      // For Angular internal
  userHasAccess: boolean;
  constructor(result?: LocationTree) {
    //console.log("LocationTree result --> ", result);
    if (result == null) {
      return;
    }
    if (result.id != null) {
      this.id = result.locationId;
      this.locationId = result.locationId
    }
    if (result.locationId != null) {
      this.locationId = result.locationId
    }
    if (result.locationName != null) {
      this.locationName = result.locationName;
      this.name = result.locationName;
    }
    this.setTreeModel(result);

  }

  // Convert server response to 'TreeModel' format for UI view.
  setTreeModel(_inp) {
    if (_inp.locationName != null) {
      this.name = _inp.locationName;
    }
    if (_inp.userHasAccess != null) {
      this.userHasAccess = _inp.userHasAccess;
    }
    if (Array.isArray(_inp.childNode)) {
      _inp.childNode.forEach((_ele) => {
        this.childNode.push(new LocationTree(_ele))
      });

    }
  }


}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/location-hierarchy/models/location-tree.ts